import USSStates from './us-states-list';

export const getStateNameFromAbbreviation = abbr => {
  if (!abbr) return null;
  const state = USSStates.find(x => x.abbr.toLowerCase() === abbr.toLowerCase());
  return state?.name;
};

export const getStateAbbreviationFromName = name => {
  if (!name) return null;
  const state = USSStates.find(x => x.name.toLowerCase() === name.toLowerCase());
  return state?.abbr;
};

export const getStateRequirements = (state) => {
  switch (state) {
    case 'CA':
      return {
        allowedRegistrationStates: ['CA'],
        allowedDeliveryStates: ['CA']
      };
    case 'NY':
      return {
        allowedRegistrationStates: ['NY'],
        allowedDeliveryStates: []
      };
    case 'IL':
      return {
        allowedRegistrationStates: ['IL'],
        allowedDeliveryStates: ['IL']
      };
    case 'OH':
      return {
        allowedRegistrationStates: ['OH'],
        allowedDeliveryStates: ['OH']
      };
    default:
      return null;
  }
};
